export default {
  template: `
  <div class="customer-bulk-delete-component">
    <div class="panel panel-default">
      <div class="panel-heading">Customer bulk delete</div>
      <div class="panel-body">
        <div class="col-md-6">
          <textarea class="form-control"
                    data-ng-model="$ctrl.emails"></textarea>
          </div>
        <div>
        <div class="col-md-6">
          <button class="btn btn-dark" 
                  data-ng-click="$ctrl.performDelete()" 
                  data-ng-disabled="!($ctrl.emails && $ctrl.emails.length > 0)">Delete customers</button>  
        </div>
        </div>
      </div>
    </div>
  </div>
  `,
  controller: class {
    constructor(customerBulkDeleteService, NotificationService) {
      this.customerBulkDeleteService = customerBulkDeleteService;
      this.notificationService = NotificationService;
      this.emails = '';
    }

    performDelete() {
      const trimEmptySpaces = email => email.trim();
      const removeEmptyStrings = email => email.length > 0;
      this.customerBulkDeleteService
        .deleteCustomers(
          this.emails
            .split(',')
            .map(trimEmptySpaces)
            .filter(removeEmptyStrings),
        )
        .then(() => this.notificationService.success('Started delete operation. You should receive and email once the it is complete'))
        .catch(() => this.notificationService.error('There was an error performing the delete'));
    }
  },
};



// WEBPACK FOOTER //
// ./src/app/customers/customer-bulk-delete/customer-bulk-delete.component.js